<template>

  <div class="content tournament-form-page">
    <div class="tf-wrap">

      <!-- Шапка -->
      <section class="adm-panel tf-head">
        <div>
          <router-link :to="id ? '/user/tournaments/overview/' + id : '/user/tournaments'" class="tf-back">
            <tkd-icon name="arrow-left"/> {{ id ? 'До турніру' : 'Усі турніри' }}
          </router-link>
          <h3 class="adm-title">{{ id ? 'Редагувати турнір' : 'Новий турнір' }} <span class="adm-count" v-if="id">#{{ id }}</span></h3>
        </div>
        <span class="adm-chip" v-if="!id" title="Незбережений новий турнір зберігається в цьому браузері кожні 30 с"><tkd-icon name="save"/> Чернетка зберігається автоматично</span>
      </section>

      <form class="adm-form tf-form" novalidate @submit.prevent="saveTournament()">

        <!-- Основне -->
        <section class="adm-section">
          <h5 class="adm-section-title"><tkd-icon name="notes"/> Основне</h5>
          <div class="adm-form-grid">
            <div class="adm-field adm-span-2" :class="{ 'has-error': errors.name }">
              <label class="adm-label" for="tf-name">Назва <span class="adm-req">*</span></label>
              <input id="tf-name" class="adm-input" type="text" placeholder="Назва турніру"
                     v-model="form.name" @input="clearError('name')">
              <div class="adm-field-error" v-if="errors.name">{{ errors.name }}</div>
            </div>
            <div class="adm-field">
              <label class="adm-label" for="tf-short">Коротка назва</label>
              <input id="tf-short" class="adm-input" type="text" placeholder="Для Telegram бота" v-model="form.shortName">
            </div>
            <div class="adm-field">
              <label class="adm-label" for="tf-date">Дата</label>
              <input id="tf-date" class="adm-input" type="text" placeholder="03.10.2019" v-model="form.date">
            </div>

            <div class="adm-field">
              <label class="adm-label">Місто</label>
              <v-select label="name" :filterable="true" :options="info.cityList"
                        v-model="form.city">
                <template slot="no-options">Виберіть місто
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    <span class="name-city">{{ option.name }}</span>
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    <span class="name-city">{{ option.name }}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <div class="adm-field">
              <label class="adm-label" for="tf-address">Адреса</label>
              <input id="tf-address" class="adm-input" type="text" placeholder="Адреса" v-model="form.address">
            </div>
            <div class="adm-field">
              <label class="adm-label" for="tf-contacts">Контакти</label>
              <input id="tf-contacts" class="adm-input" type="text" placeholder="Телефон, email" v-model="form.contacts">
            </div>
            <div class="adm-field">
              <label class="adm-label" for="tf-manager">Організатор</label>
              <input id="tf-manager" class="adm-input" type="text" placeholder="Організатор" v-model="form.manager">
            </div>
          </div>
        </section>

        <!-- Суддівська колегія -->
        <section class="adm-section">
          <h5 class="adm-section-title"><tkd-icon name="referee"/> Суддівська колегія</h5>
          <div class="adm-form-grid tf-grid-3">
            <div class="adm-field">
              <label class="adm-label" for="tf-judge">Головний суддя</label>
              <input id="tf-judge" class="adm-input" type="text" placeholder="ПІБ" v-model="form.judgename">
            </div>
            <div class="adm-field">
              <label class="adm-label" for="tf-judge2">Суддя</label>
              <input id="tf-judge2" class="adm-input" type="text" placeholder="ПІБ" v-model="form.judgename2">
            </div>
            <div class="adm-field">
              <label class="adm-label" for="tf-secretary">Секретар</label>
              <input id="tf-secretary" class="adm-input" type="text" placeholder="ПІБ" v-model="form.secretaryname">
            </div>
          </div>
        </section>

        <!-- Налаштування: по 2 варіанти — кнопки замість v-select -->
        <section class="adm-section">
          <h5 class="adm-section-title"><tkd-icon name="settings"/> Налаштування</h5>
          <div class="adm-form-grid">
            <div class="adm-field adm-span-2" v-for="setting in settingFields" :key="setting.key">
              <label class="adm-label">{{ setting.label }}</label>
              <div class="adm-choice" role="radiogroup" :aria-label="setting.label">
                <button v-for="option in info[setting.list]" :key="option.value" type="button" role="radio"
                        :aria-checked="isOptionChosen(setting.key, option) ? 'true' : 'false'"
                        :class="{ active: isOptionChosen(setting.key, option) }"
                        @click="form[setting.key] = option">{{ option.name }}</button>
              </div>
            </div>
          </div>
        </section>

        <!-- Категорії -->
        <section class="adm-section">
          <h5 class="adm-section-title"><tkd-icon name="belt"/> Категорії</h5>

          <div class="tf-stats">
            <div class="tf-stat"><b>{{getSelectedCategoriesCount('1')}}</b><span>Керугі</span></div>
            <div class="tf-stat"><b>{{getSelectedCategoriesCount('2')}}</b><span>Пумсе</span></div>
            <div class="tf-stat"><b>{{form.category_weigh_ids.length}}</b><span>Вагові</span></div>
            <div class="tf-stat total"><b>{{form.category_ids.length + form.category_weigh_ids.length}}</b><span>Всього</span></div>
            <button type="button" class="adm-btn adm-btn-sm adm-btn-danger tf-clear"
                    v-if="form.category_ids.length > 0 || form.category_weigh_ids.length > 0"
                    @click.prevent="clearAllCategories()"><tkd-icon name="close"/> Очистити всі категорії</button>
          </div>

          <!-- Керугі -->
          <div class="tf-group">
            <div class="tf-group-head">
              <h6 class="tf-group-title"><tkd-icon name="kyorugi"/> Керугі <span class="adm-count">{{ getSelectedCategoriesCount('1') }} / {{ kerugiCategories.length }}</span></h6>
              <div class="tf-group-actions">
                <button type="button" class="adm-btn adm-btn-sm" @click.prevent="selectAllKerugiCategories()"><tkd-icon name="check"/> Обрати всі</button>
                <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click.prevent="deselectAllKerugiCategories()">Зняти всі</button>
                <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click.prevent="info.kerugiCollapsed = !info.kerugiCollapsed"
                        :aria-expanded="info.kerugiCollapsed ? 'false' : 'true'">
                  <tkd-icon :name="info.kerugiCollapsed ? 'chevron-down' : 'chevron-up'"/> {{ info.kerugiCollapsed ? 'Розгорнути' : 'Згорнути' }}
                </button>
              </div>
            </div>

            <div v-show="!info.kerugiCollapsed">
              <div class="tf-age-chips">
                <button v-for="category in kerugiCategories" :key="'k-age-' + category.id"
                        type="button" class="tf-toggle"
                        :class="{ on: form.category_ids.includes(category.id) }"
                        :aria-pressed="form.category_ids.includes(category.id) ? 'true' : 'false'"
                        @click.prevent="clickCategory(category.id)">
                  <span class="tf-toggle-box" aria-hidden="true"><tkd-icon v-if="form.category_ids.includes(category.id)" name="check"/></span>
                  <span v-if="category.name === 'Дорослі'">{{category.name}} {{category.end}} та старші <small>({{calculateAge(category.end)}}+ р.)</small></span>
                  <span v-else>{{category.name}} {{category.start}}-{{category.end}} <small>({{calculateAge(category.end)}}-{{calculateAge(category.start)}} р.)</small></span>
                </button>
                <button type="button" class="adm-btn adm-btn-sm" v-if="ui.addCat.type !== '1'" @click.prevent="openAddCategory('1')"><tkd-icon name="plus"/> Нова категорія</button>
              </div>

              <div class="tf-inline-form" v-if="ui.addCat.type === '1'">
                <input class="adm-input" type="text" v-model="ui.addCat.name" placeholder="Назва (напр. Ветерани)" aria-label="Назва категорії" ref="addCatName" @keyup.enter="submitAddCategory()">
                <input class="adm-input tf-year" type="number" v-model="ui.addCat.start" placeholder="Рік з" aria-label="Рік народження з" @keyup.enter="submitAddCategory()">
                <input class="adm-input tf-year" type="number" v-model="ui.addCat.end" placeholder="Рік по" aria-label="Рік народження по" @keyup.enter="submitAddCategory()">
                <button type="button" class="adm-btn adm-btn-sm adm-btn-primary" @click.prevent="submitAddCategory()" :disabled="!canAddCategory">Додати</button>
                <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click.prevent="closeAddCategory()">Скасувати</button>
              </div>

              <div class="tf-details">
                <div class="tf-card" v-for="category in selectedKerugiCategories" :key="'k-card-' + category.id">
                  <div class="tf-card-head">
                    <b>{{category.name}}</b>
                    <div class="tf-years" v-if="category.name === 'Дорослі'">
                      <span>Рік нар.</span>
                      <input class="adm-input tf-year" type="number" v-model="category.end" placeholder="Рік" aria-label="Рік народження">
                      <span>та старші</span>
                      <small>вік {{calculateAge(category.end)}}+</small>
                    </div>
                    <div class="tf-years" v-else>
                      <span>Рік нар.</span>
                      <input class="adm-input tf-year" type="number" v-model="category.start" placeholder="З" aria-label="Рік народження з">
                      <span>–</span>
                      <input class="adm-input tf-year" type="number" v-model="category.end" placeholder="По" aria-label="Рік народження по">
                      <small>вік {{calculateAge(category.end)}}-{{calculateAge(category.start)}}</small>
                    </div>
                  </div>

                  <div class="tf-row">
                    <span class="tf-row-label">Клас</span>
                    <div class="tf-chips">
                      <label v-for="classOption in info.categoryClassOptions" :key="`${category.id}-kerugi-${classOption}`"
                             class="tf-check" :class="{ on: category.class && category.class.includes(classOption) }">
                        <input v-model="category.class" type="checkbox" :value="classOption">
                        <span>{{classOption}}</span>
                      </label>
                    </div>
                  </div>

                  <div class="tf-row" v-for="gender in genders" :key="category.id + '-k-' + gender.key">
                    <span class="tf-row-label">{{ gender.label }}</span>
                    <div class="tf-chips">
                      <button v-for="weight in category[gender.key]" :key="category.id + gender.sex + weight"
                              type="button" class="tf-toggle sm"
                              :class="{ on: checkWeightCategory(category.id, weight, gender.sex) }"
                              :aria-pressed="checkWeightCategory(category.id, weight, gender.sex) ? 'true' : 'false'"
                              @click.prevent="clickWeightCategory(category.id, weight, gender.sex)">{{weight}}</button>

                      <span class="tf-add-weight" v-if="ui.addWeight.key === category.id + '-' + gender.key">
                        <input class="adm-input tf-weight" type="text" v-model="ui.addWeight.value" placeholder="-55" aria-label="Нова вагова категорія"
                               :ref="'w-' + category.id + '-' + gender.key"
                               @keyup.enter="submitAddWeight(category, gender.key)" @keyup.esc="closeAddWeight()">
                        <button type="button" class="adm-btn adm-btn-sm adm-btn-primary" @click.prevent="submitAddWeight(category, gender.key)">Додати</button>
                        <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click.prevent="closeAddWeight()" aria-label="Скасувати"><tkd-icon name="close"/></button>
                      </span>
                      <button v-else type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click.prevent="openAddWeight(category, gender.key)">+ вага</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Пумсе -->
          <div class="tf-group">
            <div class="tf-group-head">
              <h6 class="tf-group-title"><tkd-icon name="poomsae"/> Пумсе індивідуальні <span class="adm-count">{{ getSelectedCategoriesCount('2') }} / {{ poomsaeCategories.length }}</span></h6>
              <div class="tf-group-actions">
                <button type="button" class="adm-btn adm-btn-sm" @click.prevent="selectAllPoomsaeCategories()"><tkd-icon name="check"/> Обрати всі</button>
                <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click.prevent="deselectAllPoomsaeCategories()">Зняти всі</button>
                <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click.prevent="info.poomsaeCollapsed = !info.poomsaeCollapsed"
                        :aria-expanded="info.poomsaeCollapsed ? 'false' : 'true'">
                  <tkd-icon :name="info.poomsaeCollapsed ? 'chevron-down' : 'chevron-up'"/> {{ info.poomsaeCollapsed ? 'Розгорнути' : 'Згорнути' }}
                </button>
              </div>
            </div>

            <div v-show="!info.poomsaeCollapsed">
              <div class="tf-age-chips">
                <button v-for="category in poomsaeCategories" :key="'p-age-' + category.id"
                        type="button" class="tf-toggle"
                        :class="{ on: form.category_ids.includes(category.id) }"
                        :aria-pressed="form.category_ids.includes(category.id) ? 'true' : 'false'"
                        @click.prevent="clickCategory(category.id)">
                  <span class="tf-toggle-box" aria-hidden="true"><tkd-icon v-if="form.category_ids.includes(category.id)" name="check"/></span>
                  <span v-if="category.name === 'Дорослі'">{{category.name}} {{category.end}} та старші <small>({{calculateAge(category.end)}}+ р.)</small></span>
                  <span v-else>{{category.name}} {{category.start}}-{{category.end}} <small>({{calculateAge(category.end)}}-{{calculateAge(category.start)}} р.)</small></span>
                </button>
                <button type="button" class="adm-btn adm-btn-sm" v-if="ui.addCat.type !== '2'" @click.prevent="openAddCategory('2')"><tkd-icon name="plus"/> Нова категорія пумсе</button>
              </div>

              <div class="tf-inline-form" v-if="ui.addCat.type === '2'">
                <input class="adm-input" type="text" v-model="ui.addCat.name" placeholder="Назва (напр. Майстри)" aria-label="Назва категорії пумсе" ref="addCatName" @keyup.enter="submitAddCategory()">
                <input class="adm-input tf-year" type="number" v-model="ui.addCat.start" placeholder="Рік з" aria-label="Рік народження з" @keyup.enter="submitAddCategory()">
                <input class="adm-input tf-year" type="number" v-model="ui.addCat.end" placeholder="Рік по" aria-label="Рік народження по" @keyup.enter="submitAddCategory()">
                <button type="button" class="adm-btn adm-btn-sm adm-btn-primary" @click.prevent="submitAddCategory()" :disabled="!canAddCategory">Додати</button>
                <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click.prevent="closeAddCategory()">Скасувати</button>
              </div>

              <div class="tf-details">
                <div class="tf-card" v-for="category in selectedPoomsaeCategories" :key="'p-card-' + category.id">
                  <div class="tf-card-head">
                    <b>{{category.name}}</b>
                    <div class="tf-years" v-if="category.name === 'Дорослі'">
                      <span>Рік нар.</span>
                      <input class="adm-input tf-year" type="number" v-model="category.end" placeholder="Рік" aria-label="Рік народження">
                      <span>та старші</span>
                      <small>вік {{calculateAge(category.end)}}+</small>
                    </div>
                    <div class="tf-years" v-else>
                      <span>Рік нар.</span>
                      <input class="adm-input tf-year" type="number" v-model="category.start" placeholder="З" aria-label="Рік народження з">
                      <span>–</span>
                      <input class="adm-input tf-year" type="number" v-model="category.end" placeholder="По" aria-label="Рік народження по">
                      <small>вік {{calculateAge(category.end)}}-{{calculateAge(category.start)}}</small>
                    </div>
                  </div>

                  <div class="tf-row">
                    <span class="tf-row-label">Клас</span>
                    <div class="tf-chips">
                      <label v-for="classOption in info.categoryClassOptions" :key="`${category.id}-poomsae-${classOption}`"
                             class="tf-check" :class="{ on: category.class && category.class.includes(classOption) }">
                        <input v-model="category.class" type="checkbox" :value="classOption">
                        <span>{{classOption}}</span>
                      </label>
                    </div>
                  </div>

                  <div class="tf-row">
                    <span class="tf-row-label">Тип</span>
                    <div class="tf-chips">
                      <label v-for="poomsaeOption in info.poomsaeCategoryOptions" :key="`${category.id}-poomsae-type-${poomsaeOption.value}`"
                             class="tf-check" :class="{ on: category.poomsaeCategoryTypes && category.poomsaeCategoryTypes.includes(poomsaeOption.value) }">
                        <input v-model="category.poomsaeCategoryTypes" type="checkbox" :value="poomsaeOption.value">
                        <span>{{poomsaeOption.label}}</span>
                      </label>
                    </div>
                  </div>

                  <div class="tf-row" v-for="gender in genders" :key="category.id + '-p-' + gender.key">
                    <span class="tf-row-label">{{ gender.label }}</span>
                    <div class="tf-chips">
                      <button v-for="item in category[gender.key]" :key="category.id + gender.sex + item"
                              type="button" class="tf-toggle sm"
                              :class="{ on: checkWeightCategory(category.id, item, gender.sex) }"
                              :aria-pressed="checkWeightCategory(category.id, item, gender.sex) ? 'true' : 'false'"
                              @click.prevent="clickWeightCategory(category.id, item, gender.sex)">{{item}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

                            <div class="row" style="display: none">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label>Категорії Пумсе Пари</label>
                                  <div>

                                  </div>
                                  <div style="margin-left: -5px; margin-right: -5px;">
                                    <button v-for="category in info.allCategories" v-if="category.type == 3"
                                            v-bind:class="{'btn-warning':form.category_ids.includes(category.id), ' btn-disabled':!form.category_ids.includes(category.id)} "
                                            class="btn btn-fill checkbox-list-button" @click="clickCategory(category.id)">
                                      <span class="checkbox-container"><i class="nc-icon nc-check-2" style="vertical-align: super"
                                                                          v-if="form.category_ids.includes(category.id)"></i> </span>
                                      {{category.name}} {{category.start}}-{{category.end}}
                                    </button>


                                  </div>

                                  <hr>
                                  <div>
                                    <div class="form-group" v-for="category in info.allCategories"
                                         v-if="category.type == 3 && form.category_ids.includes(category.id)">
                                      <label>{{category.name}} {{category.start}}-{{category.end}}</label>

                                      <div class="row">
                                        <div class="col-md-2 col-lg-1"><label>Чоловіки</label></div>
                                        <div class="col-md-10">
                                          <button v-for="maleWeight in category.male"
                                                  v-bind:class="{'btn-warning':checkWeightCategory(category.id, maleWeight, 'ч')} "
                                                  @click="clickWeightCategory(category.id, maleWeight, 'ч')"
                                                  class="btn btn-sm btn-fill checkbox-list-button" style="font-size: 18px;">
                                            <span class="checkbox-container"><i class="nc-icon nc-check-2"
                                                                                style="vertical-align: super"
                                                                                v-if="checkWeightCategory(category.id, maleWeight, 'ч')"></i> </span>
                                            {{maleWeight}}
                                          </button>

                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-md-2 col-lg-1"><label>Жінки</label></div>
                                        <div class="col-md-10">
                                          <button v-for="maleWeight in category.male"
                                                  v-bind:class="{'btn-warning':checkWeightCategory(category.id, maleWeight, 'ж')} "
                                                  @click="clickWeightCategory(category.id, maleWeight, 'ж')"
                                                  class="btn btn-sm btn-fill checkbox-list-button" style="font-size: 18px;">
                                            <span class="checkbox-container"><i class="nc-icon nc-check-2"
                                                                                style="vertical-align: super"
                                                                                v-if="checkWeightCategory(category.id, maleWeight, 'ж')"></i> </span>
                                            {{maleWeight}}
                                          </button>

                                        </div>
                                      </div>


                                      <hr>
                                    </div>
                                  </div>
                                  <hr>

                                </div>
                              </div>
                            </div>

        </section>

        <!-- Опис -->
        <section class="adm-section">
          <h5 class="adm-section-title"><tkd-icon name="file"/> Опис</h5>
          <div class="adm-field">
            <label class="adm-label" for="tf-notes">Важлива інформація</label>
            <textarea id="tf-notes" rows="4" class="adm-input tf-textarea"
                      placeholder="Коротко: зважування, мандатна комісія, оплата…"
                      v-model="form.notes"></textarea>
          </div>
          <div class="adm-field">
            <div class="tf-desc-head">
              <label class="adm-label" for="tf-description">Повний опис / Регламент</label>
              <div class="tf-desc-actions">
                <span class="tf-desc-hint">Шаблон:</span>
                <button type="button" class="adm-btn adm-btn-sm" @click.prevent="useTemplate('1')">Обласний</button>
                <button type="button" class="adm-btn adm-btn-sm" @click.prevent="useTemplate('2')">Міський</button>
                <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click.prevent="useTemplate('3')">Порожній</button>
                <button type="button" class="adm-btn adm-btn-sm" @click.prevent="formatDescription()"><tkd-icon name="format"/> Форматувати</button>
              </div>
            </div>
            <textarea id="tf-description" rows="15" class="adm-input tf-textarea tf-mono"
                      placeholder="Повний опис"
                      v-model="form.description"></textarea>
          </div>
        </section>

        <!-- Липкий низ: дії завжди під рукою -->
        <div class="adm-form-foot tf-foot">
          <span class="adm-form-summary" v-if="errorCount">Заповніть обовʼязкові поля ({{ errorCount }})</span>
          <span class="tf-foot-info" v-else>
            Обрано категорій: <b>{{form.category_ids.length}}</b>, вагових: <b>{{form.category_weigh_ids.length}}</b>
          </span>
          <div class="adm-form-foot-actions">
            <router-link :to="id ? '/user/tournaments/overview/' + id : '/user/tournaments'" class="adm-btn">Скасувати</router-link>
            <button type="submit" class="adm-btn adm-btn-primary" :disabled="saving">
              <tkd-icon :name="saving ? 'loader' : 'save'"/> {{ saving ? 'Збереження…' : 'Зберегти' }}
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>

</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import 'src/assets/css/tkd-theme.css';
import 'src/assets/css/tkd-admin.css';
import LTable from "@/components/Table";

const tableColumns = ['Id', 'Name', 'Salary', 'Country', 'City'];
const tableData = [{
  id: 1,
  name: 'Dakota Rice',
  salary: '$36.738',
  country: 'Niger',
  city: 'Oud-Turnhout'
},
  {
    id: 2,
    name: 'Minerva Hooper',
    salary: '$23,789',
    country: 'Curaçao',
    city: 'Sinaai-Waas'
  },
  {
    id: 3,
    name: 'Sage Rodriguez',
    salary: '$56,142',
    country: 'Netherlands',
    city: 'Baileux'
  },
  {
    id: 4,
    name: 'Philip Chaney',
    salary: '$38,735',
    country: 'Korea, South',
    city: 'Overland Park'
  },
  {
    id: 5,
    name: 'Doris Greene',
    salary: '$63,542',
    country: 'Malawi',
    city: 'Feldkirchen in Kärnten'
  }
];
export default {
  props: ['id'],
  components: {Card, LTable},
  data() {
    return {
      saving: false,
      errors: {},
      // інлайн-форми замість prompt()
      ui: {
        addCat: {type: null, name: '', start: '', end: ''},
        addWeight: {key: '', value: ''},
      },
      genders: [{key: 'male', sex: 'ч', label: 'Чоловіки'}, {key: 'female', sex: 'ж', label: 'Жінки'}],
      settingFields: [
        {key: 'protocol_type', list: 'protocolList', label: 'Друк протоколів'},
        {key: 'publish', list: 'publishList', label: 'Публікувати (Telegram бот)'},
        {key: 'registration_status', list: 'registrationStatusList', label: 'Статус реєстрації'},
        {key: 'show_draws', list: 'showDrawsList', label: 'Показувати жеребкування'},
        {key: 'only_for_activated', list: 'onlyForActivatedList', label: 'Реєстрація лише для активованих'},
      ],
      autoSaveInterval: null,
      table1: {
        columns: [...tableColumns],
        data: [...tableData]
      },
      form: {
        id: this.id,
        name: 'Новий турнір',
        shortName: '',
        notes: '',
        date: '',
        address: '',
        contacts: '',
        manager: '',
        city: '',
        publish: 0,
        protocol_type:  {name: 'З Організаціями', value: 1},
        registration_status:  {name: 'Реєстрація закрита', value: 0},
        show_draws: {name: 'Не показувати', value: 0},
        only_for_activated: {name: 'Для всіх', value: 0},
        type: '',
        description: ``,
        secretaryname: ``,
        judgename: ``,
        judgename2: ``,
        category_ids: [],
        category_weigh_ids: []
      },
      categoryList: [
        // type 1 - пумсе
        // sex 1 - male, 2- female, 0 - немає
        // poomsaeType - 1- традиционное, 2 - фристайл,
        // workType - 1- особисті, парні, командні, сімє
        // weight - для пумсе пустое поле всегда
        {id:1, type:1, ageStart:' ', ageStop:' ', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'діти', fullname:'Особисті традиційні діти хлопці'},
        {id:2, type:1, ageStart:' ', ageStop:' ', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'діти', fullname:'Особисті традиційні діти дівчата'},
        {id:3, type:1, ageStart:' ', ageStop:' ', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні молодші юнаки хлопці'},
        {id:4, type:1, ageStart:' ', ageStop:' ', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні молодші юнаки  дівчата'},
        {id:5, type:1, ageStart:' ', ageStop:' ', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні юнаки хлопці'},
        {id:6, type:1, ageStart:' ', ageStop:' ', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні юнаки дівчата'},
        {id:7, type:1, ageStart:' ', ageStop:' ', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні кадети хлопці'},
        {id:8, type:1, ageStart:' ', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні кадети дівчата'},
        {id:9, type:1, ageStart:' ', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні юніори чоловіки'},
        {id:10, type:1, ageStart:' ', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні юніори дівчата'},
        {id:11, type:1, ageStart:' ', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні чоловіки до 30'},
        {id:12, type:1, ageStart:' ', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні жінки до 30'},
        {id:13, type:1, ageStart:' ', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні чоловіки до 40'},
        {id:14, type:1, ageStart:' ', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні жінки до 40'},
        {id:15, type:1, ageStart:' ', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні чоловіки до 50'},
        {id:16, type:1, ageStart:' ', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні жінки до 50'},
        {id:17, type:1, ageStart:' ', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні чоловіки 51+'},
        {id:18, type:1, ageStart:' ', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні жінки 51+'},
        {id:19, type:1, ageStart:' ', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні жінки 31+'},
        {id:20, type:1, ageStart:' ', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Особисті традиційні чоловіки 31+'},
        {id:21, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні діти'},
        {id:22, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні молодші юнаки'},
        {id:23, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні юнаки'},
        {id:24, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні кадети'},
        {id:25, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні юніори'},
        {id:26, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні до 30'},
        {id:27, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні до 40'},
        {id:28, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні до 50'},
        {id:29, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні 51+'},
        {id:30, type:1, ageStart:' ', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні традиційні 31+'},
        {id:31, type:1, ageStart:' ', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні діти хлопці'},
        {id:32, type:1, ageStart:' ', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні діти дівчата '},
        {id:33, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні молодші юнаки хлопці'},
        {id:34, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні молодші юнаки дівчата'},
        {id:35, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні юнаки хлопці'},
        {id:36, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні юнаки дівчата'},
        {id:37, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні кадети хлопці'},
        {id:38, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні кадети дівчата'},
        {id:39, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні юніори чоловіки'},
        {id:40, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні юніори дівчата'},
        {id:41, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні чоловіки  до 30'},
        {id:42, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні жінки до 30'},
        {id:43, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні чоловіки  до 40'},
        {id:44, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні жінки до 40'},
        {id:45, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні чоловіки  до 50'},
        {id:46, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні жінки до 50'},
        {id:47, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні чоловіки  51+'},
        {id:48, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні жінки 51+'},
        {id:49, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні чоловіки  31+'},
        {id:50, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні традиційні жінки 31+'},
        {id:51, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Індивідуальні вільні до 12 хлопці'},
        {id:52, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Індивідуальні вільні до 17 хлопці'},
        {id:53, type:1, ageStart:'', ageStop:'', sex:1,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Індивідуальні вільні 18+ хлопці'},
        {id:54, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Індивідуальні вільні до 12 дівчата'},
        {id:55, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Індивідуальні вільні до 17 дівчата'},
        {id:56, type:1, ageStart:'', ageStop:'', sex:2,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Індивідуальні вільні 18+ дівчата'},
        {id:57, type:1, ageStart:'', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні вільні до 12'},
        {id:58, type:1, ageStart:'', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні вільні до 17'},
        {id:59, type:1, ageStart:'', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Парні вільні 18+'},
        {id:60, type:1, ageStart:'', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні вільні до 12'},
        {id:61, type:1, ageStart:'', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні вільні до 17'},
        {id:62, type:1, ageStart:'', ageStop:'', sex:0,  weight:'', poomsaeType:1,  workType:1,  poomsae1:'', poomsae2:'', name:'молодші юнаки', fullname:'Командні вільні 18+'},
      ],
      info: {
        kerugiCollapsed: false,
        poomsaeCollapsed: false,
        cityList: [
          {name: 'Вінниця'},
          {name: 'Київ'},
          {name: 'Київська область'},
          {name: 'Рівне'},
          {name: 'Івано-Франківськ'},
          {name: 'Луцьк'},
          {name: 'Львів'},
          {name: 'Харків'},
          {name: 'Хмельницьк'},
          {name: 'Кам\'янець-Подільський'},
        ],

        publishList: [
          {name: 'Опублікувати', value: 1},
          {name: 'Не публікувати', value: 0},
        ],

        protocolList: [
          {name: 'З Організаціями', value: 1},
          {name: 'З Областями', value: 2},
        ],
        registrationStatusList: [
          {name: 'Реєстрація відкрита', value: 1},
          {name: 'Реєстрація закрита', value: 0},
        ],
        showDrawsList: [
          {name: 'Показувати', value: 1},
          {name: 'Не показувати', value: 0},
        ],
        onlyForActivatedList: [
          {name: 'Тільки активовані', value: 1},
          {name: 'Для всіх', value: 0},
        ],
        categoryClassOptions: ['А', 'Б', 'С'],
        poomsaeCategoryOptions: [
          { value: 'traditional', label: 'Традиційні' },
          { value: 'freestyle', label: 'Вільні' }
        ],

        categoryTypes: [
          {
            id: 1,
            type: 1,
            name: 'Керугі',
            ageTypes: [
              {id: 1, name: 'Діти'}
            ],

          },
          {type: 2, name: 'Пумсе'},
        ],
        allCategories: [
          // Діти age: 2019-2020 (молодші діти)
          {
            id: 1,
            name: 'Діти',
            start: '2019',
            end: '2020',
            type: '1', // kerugi
            male: ['-16', '-18', '-20', '-22', '-24', '-26', '-28', '-30', '-32', '-34', '-37', '-41', '+41'],
            female: ['-16', '-18', '-20', '-22', '-24', '-26', '-28', '-30', '-32', '-34', '-37', '-41', '+41'],
            any: []
          },
          // Молодші юнаки age: 2017-2018
          {
            id: 2,
            name: 'Молодші юнаки',
            start: '2017',
            end: '2018',
            type: '1', // kerugi
            male: ['-20', '-22', '-24', '-26', '-28', '-30', '-32', '-34', '-37', '-41', '+41'],
            female: ['-20', '-22', '-24', '-26', '-28', '-30', '-32', '-34', '-37', '-41', '+41'],
            any: []
          },
          // Юнаки age: 2015-2016
          {
            id: 3,
            name: 'Юнаки',
            start: '2015',
            end: '2016',
            type: '1', // kerugi
            male: ['-27', '-30', '-33', '-36', '-40', '-44', '-48', '-52', '-57', '+57'],
            female: ['-27', '-30', '-33', '-36', '-40', '-44', '-48', '-52', '-57', '+57'],
            any: []
          },
          // Кадети age: 2012-2014 (старші юнаки)
          {
            id: 4,
            name: 'Кадети',
            start: '2012',
            end: '2014',
            type: '1', // kerugi
            male: ['-33', '-37', '-41', '-45', '-49', '-53', '-57', '-61', '-65', '+65'],
            female: ['-29', '-33', '-37', '-41', '-44', '-47', '-51', '-55', '-59', '+59'],
            any: []
          },
          // Юніори age: 2009-2011
          {
            id: 5,
            name: 'Юніори',
            start: '2009',
            end: '2011',
            type: '1', // kerugi
            male: ['-45', '-48', '-51', '-55', '-59', '-63', '-68', '-73', '-78', '+78'],
            female: ['-42', '-44', '-46', '-49', '-52', '-55', '-59', '-63', '-68', '+68'],
            any: []
          },
          // Молодь (чоловіки та жінки) age: 2004-2009 (ages 17-22)
          {
            id: 6,
            name: 'Молодь',
            start: '2004',
            end: '2009',
            type: '1', // kerugi
            male: ['-54', '-58', '-63', '-68', '-74', '-80', '-87', '+87'],
            female: ['-46', '-49', '-53', '-57', '-62', '-67', '-73', '+73'],
            any: []
          },
          // Дорослі age: 2009 р.н. та старші (ages 17+)
          {
            id: 7,
            name: 'Дорослі',
            start: '1950',
            end: '2009',
            type: '1', // kerugi
            male: ['-54', '-58', '-63', '-68', '-74', '-80', '-87', '+87'],
            female: ['-46', '-49', '-53', '-57', '-62', '-67', '-73', '+73'],
            any: []
          },

          // === POOMSAE CATEGORIES ===
          // Юнаки Пумсе age: 2015-2016
          {
            id: 8,
            name: 'Юнаки',
            start: '2015',
            end: '2016',
            type: '2', // poomsae
            male: ['Особисті', 'Пара', 'Команда'],
            female: ['Особисті', 'Пара', 'Команда'],
            any: [],
            qualification: '7 куп і вище',
            poomsae: ['Тегик 1', 'Тегик 2', 'Тегик 3', 'Тегик 4', 'Тегик 5', 'Тегик 6', 'Тегик 7']
          },
          // Кадети Пумсе age: 2012-2014
          {
            id: 9,
            name: 'Кадети',
            start: '2012',
            end: '2014',
            type: '2', // poomsae
            male: ['Особисті', 'Пара', 'Команда'],
            female: ['Особисті', 'Пара', 'Команда'],
            any: [],
            qualification: '5 куп і вище',
            poomsae: ['Тегик 1-8', 'Корьо', 'Кимган']
          },
          // Юніори Пумсе age: 2009-2011
          {
            id: 10,
            name: 'Юніори',
            start: '2009',
            end: '2011',
            type: '2', // poomsae
            male: ['Особисті', 'Пара', 'Команда'],
            female: ['Особисті', 'Пара', 'Команда'],
            any: [],
            qualification: '2 куп і вище',
            poomsae: ['Тегик 4-8', 'Корьо', 'Кимган', 'Тебек']
          },
          // До 30 років Пумсе age: 1996-2009
          {
            id: 11,
            name: 'До 30 років',
            start: '1996',
            end: '2009',
            type: '2', // poomsae
            male: ['Особисті', 'Пара', 'Команда'],
            female: ['Особисті', 'Пара', 'Команда'],
            any: [],
            qualification: '1 Дан і вище',
            poomsae: ['Тегик 6-8', 'Корьо', 'Кимган', 'Тебек', "П'йонвон", 'Шипшин']
          },
          // До 40 років Пумсе age: 1986-1995
          {
            id: 12,
            name: 'До 40 років',
            start: '1986',
            end: '1995',
            type: '2', // poomsae
            male: ['Особисті', 'Пара', 'Команда'],
            female: ['Особисті', 'Пара', 'Команда'],
            any: [],
            qualification: '1 Дан і вище',
            poomsae: ['Тегик 6-8', 'Корьо', 'Кимган', 'Тебек', "П'йонвон", 'Шипшин']
          },

        ]
      }
    }
  },
  computed: {
    kerugiCategories() {
      return this.info.allCategories.filter(category => category.type == 1);
    },
    poomsaeCategories() {
      return this.info.allCategories.filter(category => category.type == '2');
    },
    selectedKerugiCategories() {
      return this.kerugiCategories.filter(category => this.form.category_ids.includes(category.id));
    },
    selectedPoomsaeCategories() {
      return this.poomsaeCategories.filter(category => this.form.category_ids.includes(category.id));
    },
    errorCount() {
      return Object.keys(this.errors).length;
    },
    canAddCategory() {
      const c = this.ui.addCat;
      return !!(String(c.name).trim() && String(c.start).trim() && String(c.end).trim());
    },
    tournamentOne() {
      return this.$store.getters['tournament/tournamentOne'];
    },

    categoriesList() {
      return this.$store.getters['data/categories'];
    },

    categoriesTable() {
      let result = [];
      if (this.categoriesList) {
        // result.

      }

      return result;
    }
  },
  watch: {
    tournamentOne() {
      if (this.tournamentOne.data !== undefined && this.tournamentOne.data.item) {
        this.form.name = this.tournamentOne.data.item.name;
        this.form.address = this.tournamentOne.data.item.address;
        this.form.date = this.tournamentOne.data.item.date;
        this.form.contacts = this.tournamentOne.data.item.contacts;
        this.form.manager = this.tournamentOne.data.item.manager;
        this.form.description = this.tournamentOne.data.item.description;
        this.form.shortName = this.tournamentOne.data.item.short_name;
        this.form.notes = this.tournamentOne.data.item.notes;
        this.form.secretaryname = this.tournamentOne.data.item.secretaryname;
        this.form.judgename = this.tournamentOne.data.item.judgename;
        this.form.judgename2 = this.tournamentOne.data.item.judgename2;

        if (this.tournamentOne.data.item.allCategories) {
          try {
            this.info.allCategories = this.normalizeCategories(JSON.parse(this.tournamentOne.data.item.allCategories));
          } catch (error) {
            console.error('Failed to parse tournament categories:', error);
            this.info.allCategories = this.normalizeCategories(this.info.allCategories);
          }
        }

        if (this.tournamentOne.data.item.category_ids.length > 0) {
          this.form.category_ids = this.tournamentOne.data.item.category_ids.split(',');
          for (let ik in this.form.category_ids) {
            this.form.category_ids[ik] = parseInt(this.form.category_ids[ik]);
          }
        }

        for (let i in this.info.cityList) {
          if (this.info.cityList[i].name == this.tournamentOne.data.item.city) {
            this.form.city = this.info.cityList[i];
          }
        }

        for (let i in this.info.publishList) {
          if (this.info.publishList[i].value == this.tournamentOne.data.item.published) {
            this.form.publish = this.info.publishList[i];
          }
        }

        for (let i in this.info.registrationStatusList) {
          if (this.info.registrationStatusList[i].value == this.tournamentOne.data.item.registration_status) {
            this.form.registration_status = this.info.registrationStatusList[i];
          }
        }

        const showDrawsValue = this.parseBooleanFlag(
          this.tournamentOne.data.item.show_draws,
          this.tournamentOne.data.item.show_draw,
          0
        );
        for (let i in this.info.showDrawsList) {
          if (this.info.showDrawsList[i].value == showDrawsValue) {
            this.form.show_draws = this.info.showDrawsList[i];
          }
        }

        const onlyForActivatedValue = this.parseBooleanFlag(this.tournamentOne.data.item.only_for_activated, 0);
        for (let i in this.info.onlyForActivatedList) {
          if (this.info.onlyForActivatedList[i].value == onlyForActivatedValue) {
            this.form.only_for_activated = this.info.onlyForActivatedList[i];
          }
        }

        for (let i in this.info.protocolList) {
          if (this.info.protocolList[i].value == this.tournamentOne.data.item.protocol_type) {
            this.form.protocol_type = this.info.protocolList[i];
          }
        }


      }
    },
  },
  mounted() {
    this.info.allCategories = this.normalizeCategories(this.info.allCategories);

    if (this.form.id != undefined) {
      this.$store.dispatch('tournament/fetchTournamentOne', {id: this.id});
    } else {
      // Завантажити чернетку з localStorage
      this.loadDraft();
    }

    // Авто-збереження кожні 30 секунд
    this.autoSaveInterval = setInterval(() => {
      if (!this.form.id) { // Тільки для нових турнірів
        this.saveDraft();
      }
    }, 30000);
  },
  beforeDestroy() {
    // Очистити інтервал
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
    }
  },
  methods: {
    // значення може бути обʼєктом {name, value} або числом (publish за замовчуванням = 0)
    optionValue(current) {
      return current && typeof current === 'object' ? current.value : current;
    },
    isOptionChosen(key, option) {
      return this.optionValue(this.form[key]) == option.value;
    },
    clearError(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field);
      }
    },
    openAddCategory(type) {
      this.ui.addCat = {type: type, name: '', start: '', end: ''};
      this.$nextTick(() => this.$refs.addCatName && this.$refs.addCatName.focus && this.$refs.addCatName.focus());
    },
    closeAddCategory() {
      this.ui.addCat = {type: null, name: '', start: '', end: ''};
    },
    submitAddCategory() {
      if (!this.canAddCategory) return;
      const c = this.ui.addCat;
      if (c.type === '2') {
        this.addNewPoomsaeCategory(c.name, String(c.start), String(c.end));
      } else {
        this.addNewCategory(c.name, String(c.start), String(c.end));
      }
      this.closeAddCategory();
    },
    openAddWeight(category, gender) {
      this.ui.addWeight = {key: category.id + '-' + gender, value: ''};
      this.$nextTick(() => {
        const ref = this.$refs['w-' + category.id + '-' + gender];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el) el.focus();
      });
    },
    closeAddWeight() {
      this.ui.addWeight = {key: '', value: ''};
    },
    submitAddWeight(category, gender) {
      if (!String(this.ui.addWeight.value).trim()) return;
      this.addWeightCategory(category, gender, this.ui.addWeight.value);
      this.closeAddWeight();
    },
    // не перезаписуємо введений текст без підтвердження
    useTemplate(choice) {
      if (this.form.description && this.form.description.trim() && !confirm('Замінити поточний текст регламенту шаблоном?')) {
        return;
      }
      this.loadRegulationTemplate(choice);
    },
    successfulSaved(response) {
      console.log('\n========== successfulSaved START ==========');
      console.log('📥 Received response:', response);
      console.log('Response is null/undefined?', response == null);
      console.log('Response.status:', response?.status);
      console.log('Response.data:', response?.data);
      console.log('Response.data.item:', response?.data?.item);
      console.log('Response.data.item.id:', response?.data?.item?.id);
      
      // Clear draft and stop auto-save immediately upon successful save
      console.log('🧹 Clearing draft from localStorage...');
      localStorage.removeItem('tournamentDraft');
      
      if (this.autoSaveInterval) {
        console.log('⏱️ Stopping auto-save interval...');
        clearInterval(this.autoSaveInterval);
        this.autoSaveInterval = null;
      }
      console.log('✅ Draft cleared and auto-save stopped');
      
      // Use response directly instead of relying on store
      if (response && response.status === 200 && response.data && response.data.item && response.data.item.id > 0) {
        const tournamentId = response.data.item.id;
        console.log('✅ Valid response! Tournament ID:', tournamentId);
        console.log('🚀 Redirecting to: /user/tournaments/overview/' + tournamentId);
        
        // Redirect to the newly created/updated tournament
        this.$router.replace({ path: `/user/tournaments/overview/${tournamentId}` });
      } else {
        console.error('❌ Invalid response structure!');
        console.error('Validation failed:');
        console.error('  - response exists?', !!response);
        console.error('  - status === 200?', response?.status === 200);
        console.error('  - data exists?', !!response?.data);
        console.error('  - item exists?', !!response?.data?.item);
        console.error('  - id > 0?', response?.data?.item?.id > 0);
      }
      
      this.$notify({
        group: 'foo',
        title: 'Турнір збережено',
        type: 'success',
      });
      
      console.log('========== successfulSaved END ==========\n');
    },

    faileSaved() {
      this.$notify({
        group: 'foo',
        title: 'Помилка. Турнір не збережено...',
        type: 'error',
      });
    },

    updateProfile() {
      alert('Your data: ' + JSON.stringify(this.user))
    },
    normalizeCategory(category) {
      const categoryClass = Array.isArray(category.class)
        ? category.class
        : (typeof category.class === 'string' && category.class ? [category.class] : []);
      const hasPoomsaeCategoryTypes = Object.prototype.hasOwnProperty.call(category, 'poomsaeCategoryTypes');
      const hasLegacyPoomsaeTypes = Object.prototype.hasOwnProperty.call(category, 'poomsaeTypes');
      const poomsaeCategoryTypes = Array.isArray(category.poomsaeCategoryTypes)
        ? category.poomsaeCategoryTypes
        : (Array.isArray(category.poomsaeTypes)
          ? category.poomsaeTypes
          : (typeof category.poomsaeCategoryTypes === 'string' && category.poomsaeCategoryTypes
            ? [category.poomsaeCategoryTypes]
            : []));

      return {
        ...category,
        class: categoryClass,
        poomsaeCategoryTypes: category.type === '2'
          ? ((hasPoomsaeCategoryTypes || hasLegacyPoomsaeTypes) ? poomsaeCategoryTypes : ['traditional'])
          : poomsaeCategoryTypes
      };
    },
    normalizeCategories(categories = []) {
      return categories.map(category => this.normalizeCategory(category));
    },
    parseBooleanFlag(...values) {
      for (let i = 0; i < values.length; i++) {
        const value = values[i];
        if (value === undefined || value === null || value === '') {
          continue;
        }

        if (value === true || value === 'true') {
          return 1;
        }

        if (value === false || value === 'false') {
          return 0;
        }

        const numericValue = Number(value);
        if (!Number.isNaN(numericValue)) {
          return numericValue === 1 ? 1 : 0;
        }
      }

      return 0;
    },
    buildCategoryPayload(categories = [], selectedCategoryIds = [], selectedWeightIds = []) {
      const normalizedCategories = this.normalizeCategories(categories);
      const selectedCategoryIdSet = new Set(selectedCategoryIds.map(id => String(id)));
      const weightIdsByCategory = selectedWeightIds.reduce((acc, weightId) => {
        const parts = String(weightId).split('_');
        const categoryId = parts.shift();
        const sex = parts.pop();
        const weight = parts.join('_');

        if (!acc[categoryId]) {
          acc[categoryId] = [];
        }

        acc[categoryId].push({ weight, sex });
        return acc;
      }, {});

      let nextId = normalizedCategories.reduce((maxId, category) => {
        const numericId = Number(category.id);
        return Number.isFinite(numericId) ? Math.max(maxId, numericId) : maxId;
      }, 0) + 1;

      const payload = normalizedCategories.reduce((acc, category) => {
        const categoryId = String(category.id);
        const selectedClasses = category.class.filter(Boolean);
        const selectedPoomsaeTypes = category.type === '2'
          ? category.poomsaeCategoryTypes.filter(Boolean)
          : [];
        const categoryWeights = weightIdsByCategory[categoryId] || [];
        const classVariants = selectedClasses.length > 0 ? selectedClasses : [null];
        const poomsaeVariants = category.type === '2' && selectedPoomsaeTypes.length > 0
          ? selectedPoomsaeTypes
          : [null];

        if (selectedCategoryIdSet.has(categoryId) && (selectedClasses.length > 0 || selectedPoomsaeTypes.length > 0)) {
          classVariants.forEach(className => {
            poomsaeVariants.forEach(poomsaeType => {
              const nameParts = [];
              if (className) {
                nameParts.push(`Клас ${className}`);
              }
              nameParts.push(category.name);
              if (poomsaeType === 'traditional') {
                nameParts.push('Традиційні пумсе');
              } else if (poomsaeType === 'freestyle') {
                nameParts.push('Вільні пумсе');
              }

              const poomsaeCategoryTypes = poomsaeType ? [poomsaeType] : [];

              const clonedCategory = {
                ...category,
                id: nextId++,
                name: nameParts.join(' '),
                class: className ? [className] : [],
                poomsaeCategoryTypes
              };

              acc.categories.push(clonedCategory);
              acc.categoryIds.push(clonedCategory.id);
              categoryWeights.forEach(({ weight, sex }) => {
                acc.weightIds.push(`${clonedCategory.id}_${weight}_${sex}`);
              });
            });
          });

          return acc;
        }

        const normalizedPoomsaeTypes = category.type === '2' ? selectedPoomsaeTypes : category.poomsaeCategoryTypes;
        const baseCategory = {
          ...category,
          poomsaeCategoryTypes: normalizedPoomsaeTypes
        };

        acc.categories.push(baseCategory);
        if (selectedCategoryIdSet.has(categoryId)) {
          acc.categoryIds.push(baseCategory.id);
          categoryWeights.forEach(({ weight, sex }) => {
            acc.weightIds.push(`${baseCategory.id}_${weight}_${sex}`);
          });
        }

        return acc;
      }, {
        categories: [],
        categoryIds: [],
        weightIds: []
      });

      return payload;
    },
    saveTournament() {
      if (this.saving) return;
      this.errors = {};
      if (!String(this.form.name || '').trim()) {
        this.$set(this.errors, 'name', 'Вкажіть назву турніру');
        return;
      }
      this.saving = true;
      var params = Object.assign({}, this.form);
      params.protocol_type = this.form.protocol_type.value;
      params.registration_status = this.form.registration_status.value;
      params.show_draws = this.form.show_draws.value;
      params.only_for_activated = this.optionValue(this.form.only_for_activated) ? 1 : 0;
      params.city = params.city.name;
      params.short_name = params.shortName;
      // publish за замовчуванням — число 0, а не {name, value}
      params.published = this.optionValue(params.publish);
      const categoryPayload = this.buildCategoryPayload(
        this.info.allCategories,
        this.form.category_ids,
        this.form.category_weigh_ids
      );
      params.category_ids = categoryPayload.categoryIds.toString();
      params.category_weigh_ids = categoryPayload.weightIds.toString();
      params.allCategories = JSON.stringify(categoryPayload.categories);
      
      // For creating new tournament, remove id field completely
      if (this.id == undefined) {
        delete params.id;
        console.log('🆕 Creating NEW tournament (id removed from params)');
      } else {
        params.id = this.id;
        console.log('✏️ Updating EXISTING tournament ID:', this.id);
      }
      
      console.log('saveTournament params:', params);

      if (this.id != undefined) {
        console.log('🔄 Dispatching updateTournament...');
        this.$store.dispatch('tournament/updateTournament', params)
            .then((response) => {
              console.log('✅ updateTournament SUCCESS, response:', response);
              this.successfulSaved(response);
            })
            .catch(error => {
              console.error('❌ updateTournament FAILED in .catch()!');
              console.error('Error object:', error);
              console.error('Error type:', typeof error);
              console.error('Error message:', error?.message);
              console.error('Error response:', error?.response);
              console.error('Error stack:', error?.stack);
              this.faileSaved();
            })
            .finally(() => { this.saving = false; });
      } else {
        console.log('🆕 Dispatching createTournament...');
        this.$store.dispatch('tournament/createTournament', params)
            .then((response) => {
              console.log('✅ createTournament SUCCESS, response:', response);
              console.log('Response type:', typeof response);
              console.log('Response keys:', response ? Object.keys(response) : 'null');
              console.log('Response.data:', response?.data);
              console.log('Response.status:', response?.status);
              this.successfulSaved(response);
            })
            .catch(error => {
              console.error('❌ createTournament FAILED in .catch()!');
              console.error('Error object:', error);
              console.error('Error type:', typeof error);
              console.error('Error message:', error?.message);
              console.error('Error response:', error?.response);
              console.error('Error stack:', error?.stack);
              this.faileSaved();
            })
            .finally(() => { this.saving = false; });
      }
    },
    clickCategory(id) {
      console.log('clickCategory');

      if (this.form.category_ids.includes(id)) {
        // Remove the category
        this.form.category_ids.splice(this.form.category_ids.indexOf(id), 1);
        
        // IMPORTANT: Also remove all weight categories associated with this category
        // Weight categories have format: categoryId_weight_gender (e.g., "1_-45_ч")
        this.form.category_weigh_ids = this.form.category_weigh_ids.filter(weightId => {
          // Check if this weight ID starts with the category ID
          return !weightId.startsWith(id + '_');
        });
        
        console.log(`✅ Category ${id} removed with all weight categories`);
      } else {
        this.form.category_ids.push(id);
        // по умолчанию включаем все весовки
        // category.id, maleWeight, 'ч'

        for (let i = 0; i < this.info.allCategories.length; i++) {
          if (this.info.allCategories[i].id == id) {

            for (let ik = 0; ik < this.info.allCategories[i].male.length; ik++) {
              let idKeyM = id + '_' + this.info.allCategories[i].male[ik] + '_' + 'ч';
              this.form.category_weigh_ids.push(idKeyM);
            }
            for (let ik = 0; ik < this.info.allCategories[i].female.length; ik++) {
              let idKeyF = id + '_' + this.info.allCategories[i].female[ik] + '_' + 'ж';
              this.form.category_weigh_ids.push(idKeyF);
            }

            break;
          }

        }
        
        console.log(`✅ Category ${id} added with all weight categories`);
      }
    },


    clickWeightCategory(category, maleWeight, sex) {

      let id = category + '_' + maleWeight + '_' + sex;
      if (this.form.category_weigh_ids.includes(id)) {
        this.form.category_weigh_ids.splice(this.form.category_weigh_ids.indexOf(id), 1)
      } else {
        this.form.category_weigh_ids.push(id);
      }


      return true;
// console.log(this.form.category_weigh_ids);
      let weightCategory = {category: category, maleWeight: maleWeight, sex: sex};

      // console.log(weightCategory);
      // if (this.form.category_weigh_ids.includes(weightCategory)) {
      //   this.form.category_weigh_ids.splice(this.form.category_weigh_ids.indexOf(weightCategory), 1)
      // } else {
      //   this.form.category_weigh_ids.push(weightCategory)
      // }
      //
      //

      // перебираем все выбранные категории
      let add = true;
      for (let i = 0; i < this.form.category_weigh_ids.length; i++) {
        if (this.form.category_weigh_ids[i].category == category && this.form.category_weigh_ids[i].maleWeight == maleWeight && this.form.category_weigh_ids[i].sex == sex) {
          add = false;
          // console.log('remnove i');
          // console.log(this.form.category_weigh_ids[i]);
          this.form.category_weigh_ids.splice(i, 1);
          // console.log(weightCategory);
        }
      }

      if (add === true) {
        this.form.category_weigh_ids.push(weightCategory)
      }

    },

    // проверка выбрана ли уже категория
    checkWeightCategory(category, maleWeight, sex) {
      let id = category + '_' + maleWeight + '_' + sex;


      return this.form.category_weigh_ids.includes(id);

      // перебираем все выбранные категории
      for (let i = 0; i < this.form.category_weigh_ids.length; i++) {
        // console.log(this.form.category_weigh_ids[i]);
        if (this.form.category_weigh_ids[i].category == category && this.form.category_weigh_ids[i].maleWeight == maleWeight && this.form.category_weigh_ids[i].sex == sex) {
          return true;
        }
      }
      return false;
    },

    // Додати нову вагову категорію до існуючої секції
    addWeightCategory(category, gender, value) {
      let weight = value !== undefined ? value : prompt(`Введіть вагову категорію (наприклад: -55, +68, 50-55):`);
      if (weight && weight.trim()) {
        if (gender === 'male') {
          category.male.push(weight.trim());
        } else {
          category.female.push(weight.trim());
        }
        this.$notify({
          group: 'foo',
          title: `Вагу "${weight}" додано до категорії ${category.name}`,
          type: 'success',
        });
      }
    },

    // Додати нову кастомну категорію
    addNewCategory(nameArg, startArg, endArg) {
      // з інлайн-форми приходять значення; без них — старі prompt()
      if (nameArg !== undefined) {
        return this.pushNewCategory('1', nameArg, startArg, endArg);
      }
      let name = prompt('Введіть назву нової категорії (наприклад: Ветерани, Майстри):');
      if (!name || !name.trim()) {
        return;
      }

      let startYear = prompt('Введіть початковий рік народження (наприклад: 2000):');
      if (!startYear || !startYear.trim()) {
        return;
      }

      let endYear = prompt('Введіть кінцевий рік народження (наприклад: 2005):');
      if (!endYear || !endYear.trim()) {
        return;
      }

      // Генеруємо новий ID
      let maxId = Math.max(...this.info.allCategories.map(c => c.id));
      let newId = maxId + 1;

      let newCategory = {
        id: newId,
        name: name.trim(),
        start: startYear.trim(),
        end: endYear.trim(),
        type: '1', // kerugi
        class: [],
        male: [],
        female: [],
        any: []
      };

      this.info.allCategories.push(newCategory);
      
      this.$notify({
        group: 'foo',
        title: `Категорію "${name}" додано`,
        type: 'success',
      });
    },

    // Додати нову категорію Пумсе
    pushNewCategory(type, name, start, end) {
      const maxId = Math.max(...this.info.allCategories.map(c => c.id));
      const base = {id: maxId + 1, name: name.trim(), start: start.trim(), end: end.trim(), type: type, class: [], any: []};
      const extra = type === '2'
        ? {poomsaeCategoryTypes: ['traditional'], male: ['Особисті', 'Пара', 'Команда'], female: ['Особисті', 'Пара', 'Команда'], qualification: '1 Дан і вище', poomsae: []}
        : {male: [], female: []};
      this.info.allCategories.push(Object.assign(base, extra));
      this.$notify({group: 'foo', title: `Категорію "${name}" додано`, type: 'success'});
    },

    addNewPoomsaeCategory(nameArg, startArg, endArg) {
      if (nameArg !== undefined) {
        return this.pushNewCategory('2', nameArg, startArg, endArg);
      }
      let name = prompt('Введіть назву нової категорії Пумсе (наприклад: Ветерани, Майстри):');
      if (!name || !name.trim()) {
        return;
      }

      let startYear = prompt('Введіть початковий рік народження (наприклад: 2000):');
      if (!startYear || !startYear.trim()) {
        return;
      }

      let endYear = prompt('Введіть кінцевий рік народження (наприклад: 2005):');
      if (!endYear || !endYear.trim()) {
        return;
      }

      // Генеруємо новий ID
      let maxId = Math.max(...this.info.allCategories.map(c => c.id));
      let newId = maxId + 1;

      let newCategory = {
        id: newId,
        name: name.trim(),
        start: startYear.trim(),
        end: endYear.trim(),
        type: '2', // poomsae
        class: [],
        poomsaeCategoryTypes: ['traditional'],
        male: ['Особисті', 'Пара', 'Команда'],
        female: ['Особисті', 'Пара', 'Команда'],
        any: [],
        qualification: '1 Дан і вище',
        poomsae: []
      };

      this.info.allCategories.push(newCategory);
      
      this.$notify({
        group: 'foo',
        title: `Категорію Пумсе "${name}" додано`,
        type: 'success',
      });
    },

    // Завантажити шаблон регламенту
    loadRegulationTemplate(choice) {
      const templates = [
        {
          name: 'Обласний чемпіонат (Керугі + Пумсе)',
          content: this.getRegulationTemplateOblast()
        },
        {
          name: 'Міський чемпіонат (Керугі + Діти)',
          content: this.getRegulationTemplateCity()
        },
        {
          name: 'Порожній шаблон',
          content: ''
        }
      ];

      let templateChoice = choice !== undefined ? choice : prompt(
        'Оберіть шаблон регламенту:\n' +
        '1 - Обласний чемпіонат (Керугі + Пумсе)\n' +
        '2 - Міський чемпіонат (Керугі + Діти)\n' +
        '3 - Порожній шаблон\n\n' +
        'Введіть номер (1-3):'
      );

      let selectedTemplate = null;
      if (templateChoice === '1') selectedTemplate = templates[0];
      else if (templateChoice === '2') selectedTemplate = templates[1];
      else if (templateChoice === '3') selectedTemplate = templates[2];

      if (selectedTemplate) {
        this.form.description = selectedTemplate.content;
        this.$notify({
          group: 'foo',
          title: `Шаблон "${selectedTemplate.name}" завантажено`,
          type: 'success',
        });
      }
    },

    // Форматувати опис
    formatDescription() {
      if (!this.form.description || this.form.description.trim() === '') {
        this.$notify({
          group: 'foo',
          title: 'Немає тексту для форматування',
          type: 'warning',
        });
        return;
      }

      // Базове форматування
      let formatted = this.form.description;
      
      // Видалити зайві пробіли в кінці рядків
      formatted = formatted.replace(/[ \t]+$/gm, '');
      
      // Видалити більше ніж 2 порожніх рядків підряд
      formatted = formatted.replace(/\n{3,}/g, '\n\n');

      this.form.description = formatted;
      
      this.$notify({
        group: 'foo',
        title: 'Текст відформатовано',
        type: 'success',
      });
    },

    // Шаблон обласного регламенту
    getRegulationTemplateOblast() {
      const year = new Date().getFullYear();
      const month = new Date().toLocaleDateString('uk-UA', { month: 'long' });
      
      return `РЕГЛАМЕНТ
Відкритого чемпіонату Вінницької області з тхеквондо (ВТФ)
у розділі «керугі» та пумсе

1. МЕТА І ЗАВДАННЯ

Мета: визначення рівня кращих спортсменів області для формування збірних команд.

Завдання:
- сприяння популяризації тхеквондо (ВТФ)
- підвищення рівня майстерності спортсменів
- патріотичне виховання спортивної громадськості

2. КЕРІВНИЦТВО ПРОВЕДЕННЯ ЗМАГАНЬ

Загальне керівництво організацією змагань здійснюється Департаментом гуманітарної політики.
Під час оголошення команди «Повітряна тривога» змагання зупиняються.

3. СТРОКИ ТА МІСЦЕ ПРОВЕДЕННЯ

Змагання проводяться: [ДАТА]
Місце: [АДРЕСА]

4. ПРОГРАМА ЗМАГАНЬ

[ДАТА] - Мандатна комісія, зважування, жеребкування
[ДАТА] - Змагання

5. УЧАСНИКИ ЗМАГАНЬ

До участі допускаються спортсмени з діючими:
- класифікаційною книжкою
- атестаційним сертифікатом
- страховим полісом
- допуском лікаря

6. ВІКОВІ КАТЕГОРІЇ ТА КВАЛІФІКАЦІЯ

[ДОДАЙТЕ КАТЕГОРІЇ З ФОРМИ]

7. УМОВИ ПРОВЕДЕННЯ

Змагання проводяться за правилами WT.
Електронна система: Dae-do

8. НАГОРОДЖЕННЯ

Призери нагороджуються грамотами та медалями.

9. ФІНАНСОВІ ВИТРАТИ

Витрати на проїзд та харчування несуть організації, які відряджують.

10. ПОДАЧА ЗАЯВОК

Попередні заявки до: [ДАТА]
Email: taekwondo.vinnytsia@gmail.com
`;
    },

    // Шаблон міського регламенту
    getRegulationTemplateCity() {
      return `РЕГЛАМЕНТ
Відкритий чемпіонат міської територіальної громади
з тхеквондо (ВТФ) у розділі «керугі»

1. МЕТА І ЗАВДАННЯ

Мета: визначення кращих спортсменів для збірних команд.

Завдання:
- популяризація тхеквондо
- підвищення майстерності
- здоровий спосіб життя

2. КЕРІВНИЦТВО

Організація: Комітет по фізичній культурі і спорту
Проведення: Федерація тхеквондо (ВТФ)

3. ДАТА ТА МІСЦЕ

Дата: [ДАТА]
Місце: [АДРЕСА]

4. ПРОГРАМА

[ДАТА]:
10:00-14:00 - Мандатна комісія
14:00-16:00 - Зважування
16:00-17:00 - Жеребкування

[ДАТА]:
09:00 - Початок змагань
10:00-10:20 - Урочисте відкриття

5. УЧАСНИКИ

Спортсмени з необхідними документами та допуском.

6. КАТЕГОРІЇ

[ДОДАЙТЕ КАТЕГОРІЇ]

7. УМОВИ ПРОВЕДЕННЯ

Правила: WT
Система: Dae-do

8. НАГОРОДЖЕННЯ

Дипломи та медалі для призерів.

9. ЗАЯВКИ

Email: taekwondo.vinnytsia@gmail.com
До: [ДАТА]
`;
    },

    // Обчислити вік на основі року народження
    calculateAge(birthYear) {
      const currentYear = new Date().getFullYear();
      return currentYear - parseInt(birthYear);
    },

    // Порахунок обраних категорій за типом
    getSelectedCategoriesCount(type) {
      return this.info.allCategories.filter(cat => 
        cat.type === type && this.form.category_ids.includes(cat.id)
      ).length;
    },

    // Очистити всі категорії та скинути до заводських налаштувань
    clearAllCategories() {
      if (confirm('Ви впевнені, що хочете очистити всі обрані категорії та скинути до заводських налаштувань?')) {
        this.form.category_ids = [];
        this.form.category_weigh_ids = [];
        
        // Скинути категорії до заводських значень
        this.info.allCategories = this.getDefaultCategories();
        
        // Очистити чернетку
        localStorage.removeItem('tournamentDraft');
        
        this.$notify({
          group: 'foo',
          title: 'Всі категорії очищено та скинуто до заводських налаштувань',
          type: 'success',
        });
      }
    },

    // Отримати заводські категорії
    getDefaultCategories() {
      return [
        // Діти age: 2019-2020 (молодші діти)
        {
          id: 1,
          name: 'Діти',
          start: '2019',
          end: '2020',
          type: '1',
          male: ['-16', '-18', '-20', '-22', '-24', '-26', '-28', '-30', '-32', '-34', '-37', '-41', '+41'],
          female: ['-16', '-18', '-20', '-22', '-24', '-26', '-28', '-30', '-32', '-34', '-37', '-41', '+41'],
          any: []
        },
        // Молодші юнаки age: 2017-2018
        {
          id: 2,
          name: 'Молодші юнаки',
          start: '2017',
          end: '2018',
          type: '1',
          male: ['-20', '-22', '-24', '-26', '-28', '-30', '-32', '-34', '-37', '-41', '+41'],
          female: ['-20', '-22', '-24', '-26', '-28', '-30', '-32', '-34', '-37', '-41', '+41'],
          any: []
        },
        // Юнаки age: 2015-2016
        {
          id: 3,
          name: 'Юнаки',
          start: '2015',
          end: '2016',
          type: '1',
          male: ['-27', '-30', '-33', '-36', '-40', '-44', '-48', '-52', '-57', '+57'],
          female: ['-27', '-30', '-33', '-36', '-40', '-44', '-48', '-52', '-57', '+57'],
          any: []
        },
        // Кадети age: 2012-2014
        {
          id: 4,
          name: 'Кадети',
          start: '2012',
          end: '2014',
          type: '1',
          male: ['-33', '-37', '-41', '-45', '-49', '-53', '-57', '-61', '-65', '+65'],
          female: ['-29', '-33', '-37', '-41', '-44', '-47', '-51', '-55', '-59', '+59'],
          any: []
        },
        // Юніори age: 2009-2011
        {
          id: 5,
          name: 'Юніори',
          start: '2009',
          end: '2011',
          type: '1',
          male: ['-45', '-48', '-51', '-55', '-59', '-63', '-68', '-73', '-78', '+78'],
          female: ['-42', '-44', '-46', '-49', '-52', '-55', '-59', '-63', '-68', '+68'],
          any: []
        },
        // Молодь age: 2004-2009
        {
          id: 6,
          name: 'Молодь',
          start: '2004',
          end: '2009',
          type: '1',
          male: ['-54', '-58', '-63', '-68', '-74', '-80', '-87', '+87'],
          female: ['-46', '-49', '-53', '-57', '-62', '-67', '-73', '+73'],
          any: []
        },
        // Дорослі age: 2009 р.н. та старші
        {
          id: 7,
          name: 'Дорослі',
          start: '1950',
          end: '2009',
          type: '1',
          male: ['-54', '-58', '-63', '-68', '-74', '-80', '-87', '+87'],
          female: ['-46', '-49', '-53', '-57', '-62', '-67', '-73', '+73'],
          any: []
        },
        // === POOMSAE CATEGORIES ===
        {
          id: 8,
          name: 'Юнаки',
          start: '2015',
          end: '2016',
          type: '2',
          male: ['Особисті', 'Пара', 'Команда'],
          female: ['Особисті', 'Пара', 'Команда'],
          any: [],
          qualification: '7 куп і вище',
          poomsae: ['Тегик 1', 'Тегик 2', 'Тегик 3', 'Тегик 4', 'Тегик 5', 'Тегик 6', 'Тегик 7']
        },
        {
          id: 9,
          name: 'Кадети',
          start: '2012',
          end: '2014',
          type: '2',
          male: ['Особисті', 'Пара', 'Команда'],
          female: ['Особисті', 'Пара', 'Команда'],
          any: [],
          qualification: '5 куп і вище',
          poomsae: ['Тегик 1-8', 'Корьо', 'Кимган']
        },
        {
          id: 10,
          name: 'Юніори',
          start: '2009',
          end: '2011',
          type: '2',
          male: ['Особисті', 'Пара', 'Команда'],
          female: ['Особисті', 'Пара', 'Команда'],
          any: [],
          qualification: '2 куп і вище',
          poomsae: ['Тегик 4-8', 'Корьо', 'Кимган', 'Тебек']
        },
        {
          id: 11,
          name: 'До 30 років',
          start: '1996',
          end: '2009',
          type: '2',
          male: ['Особисті', 'Пара', 'Команда'],
          female: ['Особисті', 'Пара', 'Команда'],
          any: [],
          qualification: '1 Дан і вище',
          poomsae: ['Тегик 6-8', 'Корьо', 'Кимган', 'Тебек', "П'йонвон", 'Шипшин']
        },
        {
          id: 12,
          name: 'До 40 років',
          start: '1986',
          end: '1995',
          type: '2',
          male: ['Особисті', 'Пара', 'Команда'],
          female: ['Особисті', 'Пара', 'Команда'],
          any: [],
          qualification: '1 Дан і вище',
          poomsae: ['Тегик 6-8', 'Корьо', 'Кимган', 'Тебек', "П'йонвон", 'Шипшин']
        }
      ];
    },

    // Обрати всі категорії Керугі
    selectAllKerugiCategories() {
      const kerugiCategories = this.info.allCategories.filter(cat => cat.type === '1');
      kerugiCategories.forEach(cat => {
        if (!this.form.category_ids.includes(cat.id)) {
          this.form.category_ids.push(cat.id);
        }
        
        // Автоматично обрати всі вагові категорії
        cat.male.forEach(weight => {
          const idKeyM = `${cat.id}_${weight}_ч`;
          if (!this.form.category_weigh_ids.includes(idKeyM)) {
            this.form.category_weigh_ids.push(idKeyM);
          }
        });
        
        cat.female.forEach(weight => {
          const idKeyF = `${cat.id}_${weight}_ж`;
          if (!this.form.category_weigh_ids.includes(idKeyF)) {
            this.form.category_weigh_ids.push(idKeyF);
          }
        });
      });
      this.$notify({
        group: 'foo',
        title: `Обрано ${kerugiCategories.length} категорій Керугі з усіма ваговими категоріями`,
        type: 'success',
      });
    },

    // Зняти всі категорії Керугі
    deselectAllKerugiCategories() {
      const kerugiCategories = this.info.allCategories.filter(cat => cat.type === '1');
      kerugiCategories.forEach(cat => {
        const index = this.form.category_ids.indexOf(cat.id);
        if (index > -1) {
          this.form.category_ids.splice(index, 1);
        }
        // Також видалити вагові категорії цієї категорії
        this.form.category_weigh_ids = this.form.category_weigh_ids.filter(wid => 
          !wid.startsWith(`${cat.id}_`)
        );
      });
      this.$notify({
        group: 'foo',
        title: 'Всі категорії Керугі знято',
        type: 'info',
      });
    },

    // Обрати всі категорії Пумсе
    selectAllPoomsaeCategories() {
      const poomsaeCategories = this.info.allCategories.filter(cat => cat.type === '2');
      poomsaeCategories.forEach(cat => {
        if (!this.form.category_ids.includes(cat.id)) {
          this.form.category_ids.push(cat.id);
        }
        
        // Автоматично обрати всі категорії Пумсе
        cat.male.forEach(item => {
          const idKeyM = `${cat.id}_${item}_ч`;
          if (!this.form.category_weigh_ids.includes(idKeyM)) {
            this.form.category_weigh_ids.push(idKeyM);
          }
        });
        
        cat.female.forEach(item => {
          const idKeyF = `${cat.id}_${item}_ж`;
          if (!this.form.category_weigh_ids.includes(idKeyF)) {
            this.form.category_weigh_ids.push(idKeyF);
          }
        });
      });
      this.$notify({
        group: 'foo',
        title: `Обрано ${poomsaeCategories.length} категорій Пумсе з усіма категоріями`,
        type: 'success',
      });
    },

    // Зняти всі категорії Пумсе
    deselectAllPoomsaeCategories() {
      const poomsaeCategories = this.info.allCategories.filter(cat => cat.type === '2');
      poomsaeCategories.forEach(cat => {
        const index = this.form.category_ids.indexOf(cat.id);
        if (index > -1) {
          this.form.category_ids.splice(index, 1);
        }
        // Також видалити вагові категорії цієї категорії
        this.form.category_weigh_ids = this.form.category_weigh_ids.filter(wid => 
          !wid.startsWith(`${cat.id}_`)
        );
      });
      this.$notify({
        group: 'foo',
        title: 'Всі категорії Пумсе знято',
        type: 'info',
      });
    },

    // Зберегти чернетку в localStorage
    saveDraft() {
      try {
        const draft = {
          form: this.form,
          allCategories: this.info.allCategories,
          timestamp: new Date().toISOString()
        };
        localStorage.setItem('tournamentDraft', JSON.stringify(draft));
        console.log('💾 Чернетку збережено', new Date().toLocaleTimeString());
      } catch (e) {
        console.error('Помилка збереження чернетки:', e);
      }
    },

    // Завантажити чернетку з localStorage
    loadDraft() {
      try {
        const draftStr = localStorage.getItem('tournamentDraft');
        if (draftStr) {
          const draft = JSON.parse(draftStr);
          const draftDate = new Date(draft.timestamp);
          const hoursSince = (new Date() - draftDate) / (1000 * 60 * 60);
          
          // Завантажити автоматично якщо чернетці менше 24 годин
          if (hoursSince < 24) {
            this.form = draft.form;
            this.info.allCategories = this.normalizeCategories(draft.allCategories);
            if (!this.form.show_draws || this.form.show_draws.value === undefined) {
              this.form.show_draws = this.info.showDrawsList[0].value === this.parseBooleanFlag(this.form.show_draws)
                ? this.info.showDrawsList[0]
                : this.info.showDrawsList[1];
            }
            // старі чернетки не мають only_for_activated
            if (!this.form.only_for_activated || this.form.only_for_activated.value === undefined) {
              this.$set(this.form, 'only_for_activated', this.info.onlyForActivatedList[1]);
            }
            this.$notify({
              group: 'foo',
              title: `Чернетку від ${draftDate.toLocaleString()} завантажено`,
              type: 'success',
            });
            console.log('✅ Чернетку автоматично завантажено');
          } else {
            // Чернетка застаріла
            localStorage.removeItem('tournamentDraft');
            console.log('🗑️ Стару чернетку видалено');
          }
        }
      } catch (e) {
        console.error('Помилка завантаження чернетки:', e);
      }
    },
  }
}

</script>
<style>
.checkbox-list-button {
  margin: 5px;
}

.checkbox-list-button > span > i {
  font-weight: bold;
  vertical-align: super;
}

.checkbox-container {
  border: 1px solid rgb(204, 204, 204);
  padding: 2px;
  display: inline-block;
  width: 18px;
  height: 18px;
  vertical-align: middle;
}

.checkbox-container i {
  font-size: 12px;
}

/* Category Overview Section Improvements */
.category-overview-box {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px solid #51cbce;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: 0 4px 12px rgba(81, 203, 206, 0.15);
}

.category-overview-title {
  color: #51cbce;
  font-size: 20px;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.category-overview-title i {
  margin-right: 10px;
  font-size: 22px;
}

.category-stat-card {
  background: white;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.category-stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.category-stat-label {
  font-size: 13px;
  color: #6c757d;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.category-stat-badge {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 18px;
  font-weight: 700;
  color: white;
  min-width: 50px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.badge-kerugi {
  background: linear-gradient(135deg, #51cbce 0%, #3aafb3 100%);
}

.badge-poomsae {
  background: linear-gradient(135deg, #6bd098 0%, #51b578 100%);
}

.badge-weight {
  background: linear-gradient(135deg, #fbc658 0%, #f7a825 100%);
}

.badge-total {
  background: linear-gradient(135deg, #ef8157 0%, #d96843 100%);
}

.clear-all-btn {
  margin-top: 15px;
}

.clear-all-btn .btn {
  background: linear-gradient(135deg, #ef8157 0%, #d96843 100%);
  border: none;
  color: white;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 0 3px 8px rgba(239, 129, 87, 0.3);
  transition: all 0.3s ease;
}

.clear-all-btn .btn:hover {
  background: linear-gradient(135deg, #d96843 0%, #c35533 100%);
  box-shadow: 0 5px 12px rgba(239, 129, 87, 0.4);
  transform: translateY(-2px);
}

.clear-all-btn .btn i {
  margin-right: 8px;
}
</style>

<style scoped>
.tournament-form-page { font-family: var(--tkd-font); color: var(--tkd-text); }
.tf-wrap { width: 100%; max-width: 1100px; margin: 0 auto; padding: 24px 15px 40px; }
.tf-head { display: flex; flex-wrap: wrap; align-items: flex-end; justify-content: space-between; gap: 12px; }
.tf-back { display: inline-block; margin-bottom: 6px; font-size: 13px; font-weight: 600; color: var(--tkd-muted); }
.tf-back:hover { color: var(--tkd-text); text-decoration: none; }
.tf-form { max-height: none; background: transparent; }
.tf-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.tf-stats { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-bottom: 16px; }
.tf-stat { display: flex; align-items: baseline; gap: 6px; padding: 8px 14px; border: 1px solid var(--tkd-border); border-radius: var(--tkd-radius); background: var(--tkd-bg); }
.tf-stat b { font-size: 20px; font-weight: 800; }
.tf-stat span { font-size: 13px; color: var(--tkd-muted); }
.tf-stat.total { border-color: var(--tkd-navy); background: var(--tkd-navy); color: #fff; }
.tf-stat.total span { color: rgba(255, 255, 255, 0.75); }
.tf-clear { margin-left: auto; }
.tf-group { margin-bottom: 16px; padding: 14px; border: 1px solid var(--tkd-border); border-radius: var(--tkd-radius-lg); }
.tf-group-head { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 12px; }
.tf-group-title { display: flex; align-items: center; gap: 8px; margin: 0; font-size: 16px; font-weight: 800; text-transform: none; }
.tf-group-actions, .tf-age-chips, .tf-chips { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
.tf-toggle { display: inline-flex; align-items: center; gap: 8px; min-height: 36px; margin: 0; padding: 4px 12px; border: 1.5px solid var(--tkd-border); border-radius: 999px; background: var(--tkd-surface); font-size: 14px; font-weight: 600; color: var(--tkd-text); cursor: pointer; }
.tf-toggle small { font-weight: 500; color: var(--tkd-muted); }
.tf-toggle:hover { border-color: var(--tkd-muted); }
.tf-toggle.on { border-color: var(--tkd-navy); background: var(--tkd-navy); color: #fff; }
.tf-toggle.on small { color: rgba(255, 255, 255, 0.75); }
.tf-toggle:focus-visible, .tf-check:focus-within { outline: none; box-shadow: var(--adm-focus); }
.tf-toggle.sm { min-height: 32px; padding: 2px 12px; font-size: 13px; }
.tf-toggle-box { display: inline-flex; align-items: center; justify-content: center; width: 16px; height: 16px; border: 1.5px solid currentColor; border-radius: 4px; font-size: 11px; }
.tf-inline-form { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; padding: 10px; border: 1px dashed var(--tkd-border); border-radius: var(--tkd-radius); background: var(--tkd-bg); }
.tf-inline-form .adm-input { flex: 1 1 180px; height: 36px; }
.tf-inline-form .adm-input.tf-year { flex: 0 0 100px; }
.tf-details { display: flex; flex-direction: column; gap: 10px; margin-top: 14px; }
.tf-card { padding: 12px 14px; border: 1px solid var(--tkd-border); border-radius: var(--tkd-radius); background: var(--tkd-bg); }
.tf-card-head { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin-bottom: 8px; }
.tf-card-head b { font-size: 15px; }
.tf-years { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; font-size: 13px; color: var(--tkd-muted); }
.adm-input.tf-year { width: 90px; height: 34px; padding: 0 8px; }
.tf-row { display: grid; grid-template-columns: 80px minmax(0, 1fr); gap: 8px; align-items: center; padding: 4px 0; }
.tf-row-label { font-size: 12px; font-weight: 700; text-transform: uppercase; color: var(--tkd-muted); }
.tf-check { display: inline-flex; align-items: center; gap: 6px; height: 32px; margin: 0; padding: 0 12px; border: 1.5px solid var(--tkd-border); border-radius: 999px; background: var(--tkd-surface); font-size: 13px; font-weight: 600; text-transform: none; cursor: pointer; }
.tf-check input { margin: 0; accent-color: var(--tkd-navy); }
.tf-check.on { border-color: var(--tkd-navy); }
.tf-add-weight { display: inline-flex; gap: 4px; }
.adm-input.tf-weight { width: 80px; height: 32px; padding: 0 8px; }
.tf-textarea { height: auto; padding: 10px 12px; line-height: 1.5; resize: vertical; }
.tf-mono { font-family: monospace; white-space: pre-wrap; }
.tf-desc-head { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 6px; }
.tf-desc-actions { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
.tf-desc-hint { font-size: 12px; color: var(--tkd-muted); }
.tf-foot { position: sticky; bottom: 0; z-index: 5; border: 1px solid var(--tkd-border); border-radius: var(--tkd-radius-lg); box-shadow: 0 -8px 24px rgba(10, 31, 68, 0.08); }
.tf-foot-info { font-size: 13px; color: var(--tkd-muted); }
@media (max-width: 767px) {
  .tf-grid-3 { grid-template-columns: minmax(0, 1fr); }
  .tf-row { grid-template-columns: minmax(0, 1fr); }
  .tf-clear { margin-left: 0; }
}
</style>
